import React from 'react';

import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

import type { SuggestionAndStatus } from '../../../ChatPanelMarkdown';

const useStyles = makeStyles()(theme => ({
  explanationContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },
  sectionTitle: {
    fontStyle: 'italic',
    textDecoration: 'underline',
  },
}));

interface SuggestionItemExplanationProps {
  suggestion: SuggestionAndStatus['suggestion'];
}

export const SuggestionItemExplanation = React.memo(function SuggestionItemExplanation({
  suggestion,
}: SuggestionItemExplanationProps): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.explanationContainer}>
      <Typography className={classes.sectionTitle}>Explanation:</Typography>
      <Typography>{suggestion.reason}</Typography>
    </div>
  );
});
